import ContactAutocomplete from "./ContactAutocomplete";
import { ClientWorkflow, ContactNotificationType } from "@avenueops/shared-types";
import { Button, Toggle } from "@avenueops/web-components";
import { NotificationType } from "@prisma/client";
import NotificationInput from "components/notifications/NotificationInput";
import React from "react";
import { useFormContext } from "react-hook-form";

interface Props {
  prefix: string;
  index: number;
  remove: any;
  manualOnly?: boolean;
  disableCustomize?: boolean;
  workflow?: ClientWorkflow;
}

export default function SubscriberInput({ prefix, index, remove, manualOnly, disableCustomize, workflow }: Props): JSX.Element {
  const { register, unregister, watch, setValue } = useFormContext();
  const notificationPrefix = `${prefix}.${index}`;
  const notification: ContactNotificationType = watch(notificationPrefix);
  const [isManual, setIsManual] = React.useState<boolean>("manualType" in notification && notification.manualType !== undefined);

  return (
    <div key={notificationPrefix} className="flex flex-col items-start gap-2 sm:flex-row">
      {!manualOnly ? (
        <Toggle
          title="Manual"
          titleAlignment="VERTICAL"
          name={`${notificationPrefix}.manual`}
          onChange={() => {
            setIsManual(!isManual);
            if (isManual) {
              setValue(`${prefix}.${index}.manualType`, undefined, { shouldDirty: true });
            } else {
              setValue(`${prefix}.${index}.manualType`, NotificationType.SMS, { shouldDirty: true });
            }
          }}
          value={isManual}
          defaultValue={isManual}
        />
      ) : null}
      <div className="w-full flex gap-2 justify-between">
        {isManual || manualOnly ? (
          <NotificationInput notificationPrefix={notificationPrefix} disableCustomize={disableCustomize} />
        ) : (
          <ContactAutocomplete notificationPrefix={notificationPrefix} priority={workflow?.priority} />
        )}
        <div className={`flex-shrink-0 pt-6`}>
          <Button type="DANGER_SECONDARY" onClick={() => remove(index)}>
            -
          </Button>
        </div>
      </div>
    </div>
  );
}
